import * as React from "react";
import { TooltipHost } from "@fluentui/react";
import { useSelector } from "react-redux";
import { LanguageContext } from "../../../../utilities/LocalizationModule";
import { selectChosenUniqueIds } from "../../redux/modules/copilot";
import { CopilotLogo } from "./CopilotLogo";
import { copilotClassNames } from "./copilotStyles";

export interface ICopilotFileBadgeProps {
  /** The list item's UniqueId as the grid has it: braces and case are normalised here. */
  uniqueId: string;
}

/**
 * The Copilot mark right after a library row's name when the file or folder is among Copilot's chosen
 * files (spec 2026-10-22 §2.5). Fluent's list does not re-render rows for outside state, so the
 * badge subscribes itself; the selector returns a boolean, so only a row whose membership changes
 * re-renders.
 */
export const CopilotFileBadge: React.FC<ICopilotFileBadgeProps> = ({ uniqueId }: ICopilotFileBadgeProps) => {
  const strings = React.useContext(LanguageContext);
  const id: string = (uniqueId ?? "").replace(/[{}]/g, "").toLowerCase();
  const isChosen: boolean = useSelector((state: any) => id !== "" && selectChosenUniqueIds(state).has(id));
  if (!isChosen) {
    return null;
  }
  return (
    <TooltipHost content={strings.CopilotInCopilot} hostClassName={copilotClassNames.fileBadgeHost}>
      <span role="img" aria-label={strings.CopilotInCopilot} className={copilotClassNames.fileBadge}>
        <CopilotLogo size={20} />
      </span>
    </TooltipHost>
  );
};
